import app from 'firebase/app';

export const createStripeCustomer = data => {
    const createStripeCustomerFn = app.functions().httpsCallable('createStripeCustomer');

    return createStripeCustomerFn(data);
};

export const attachPaymentMethod = (paymentMethodId, customerId) => {
    const createStripeCustomerFn = app.functions().httpsCallable('attachPaymentMethod');

    return createStripeCustomerFn({
        paymentMethodId,
        customerId,
    });
};

export const detachesPaymentMethod = paymentMethodId => {
    const detachesPaymentMethodFn = app.functions().httpsCallable('detachesPaymentMethod');
    return detachesPaymentMethodFn({
        paymentMethodId,
    });
};

export const createPaymentIntents = dto => {
    const createPaymentIntentsFn = app.functions().httpsCallable('createPaymentIntents');
    return createPaymentIntentsFn(dto);
};

export const confirmUserOauth = code => {
    const confirmUserOauthFn = app.functions().httpsCallable('confirmUserOauth');
    return confirmUserOauthFn({ code });
};

export const getUserPaymentMethods = customerId => {
    const getUserPaymentMethodsFn = app.functions().httpsCallable('getUserPaymentMethods');

    return getUserPaymentMethodsFn({
        customerId,
    });
};

export const createAccount = async token => {
    let stripeCreateAccount = app.functions().httpsCallable('stripeCreateAccount');
    return await stripeCreateAccount(token);
};

export const payByReview = async (review_id, token) => {
    let stripePay = app.functions().httpsCallable('stripePay');
    return await stripePay({ review_id, token });
};

export const createTransaction = async data => {
    return app.firestore().collection('transactions').add(data);
};

export const createTransfer = data => {
    return app.functions().httpsCallable('createTransfer')(data);
};
